// extracted by mini-css-extract-plugin
export default {"pageWrapper":"OnePageSecondStyle_pageWrapper__ceIPa","contentWrapper":"OnePageSecondStyle_contentWrapper__hOmI3"};